import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@env';

import { Tag, TagsResponse, TaggableType } from '../../../interfaces/tag.interface';
import { TagsApiService } from './tags-api.service';

/** Cliente del catálogo de etiquetas, en la API transversal (`TerraEnergyShared-Api`). */
@Injectable()
export class TagsHttpService extends TagsApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.sharedApiGateway}tags`;

  list(type: TaggableType): Observable<TagsResponse> {
    return this.http.get<TagsResponse>(this.baseUrl, {
      params: new HttpParams().set('filter[type]', type),
    });
  }

  create(type: TaggableType, name: string): Observable<Tag> {
    return this.http.post<Tag>(this.baseUrl, { taggable_type: type, name });
  }

  update(
    id: number,
    patch: { name?: string; color?: string | null; is_active?: boolean },
  ): Observable<Tag> {
    return this.http.patch<Tag>(`${this.baseUrl}/${id}`, patch);
  }
}
